var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.isClickable ? 'button' : 'div',{tag:"component",staticClass:"jdsc-score-badge",class:_vm.classes,on:{"click":function($event){$event.preventDefault();return _vm.emitClick($event)}}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }